module.exports = __webpack_public_path__ + "static/scale-model-of-texas-capitol-visitors-center-in-austin-texas-3a643c541916875e279b4cdbf557958d.png";